import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWave: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-0-stroke-1.5-IconWave"><Path d="M12 3C12.4142 3 12.75 3.33579 12.75 3.75V19.5H16.25V11.5C16.25 11.0858 16.5858 10.75 17 10.75H21.25C21.6642 10.75 22 11.0858 22 11.5C22 11.9142 21.6642 12.25 21.25 12.25H17.75V20.25C17.75 20.6642 17.4142 21 17 21H12C11.5858 21 11.25 20.6642 11.25 20.25V4.5H7.75V12C7.75 12.4142 7.41421 12.75 7 12.75H2.75C2.33579 12.75 2 12.4142 2 12C2 11.5858 2.33579 11.25 2.75 11.25H6.25V3.75C6.25 3.33579 6.58579 3 7 3H12Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWave;
